/*global Modernizr, trapFocus, console */
/*jslint browser:true */

(function() {
  'use strict';

  var search_modal_container = document.getElementById('modal-search');

  if(search_modal_container) {
    search_modal_container.addEventListener('modal-open', (e) => {
      setTimeout(function() {
        search_modal_container.querySelector('input').focus();
        trapFocus(search_modal_container);
      }, 30);
    });
  }
}());